import { OEText } from '@openeducation/oe-it-components';
import { styled, secondaryFontFamily } from '@openeducation/oe-it-themes';
import React from 'react';
import { ViewProps } from 'react-native';

export interface CardProps extends ViewProps {
  fullWidth?: boolean;
  flex?: boolean;
  title?: string;
  children: React.ReactNode;
  rightContent?: React.ReactNode;
}

export const Card = ({
  fullWidth = false,
  flex,
  title,
  children,
  rightContent,
  style,
}: CardProps) => {
  return (
    <Container fullWidth={fullWidth} flex={flex} style={style}>
      {!!title && (
        <TitleContainer>
          <Title>{title}</Title>
          {rightContent}
        </TitleContainer>
      )}
      <InnerContainer hasTitle={!!title}>{children}</InnerContainer>
    </Container>
  );
};

interface ContainerProps {
  fullWidth: boolean;
  flex?: boolean;
}

const Container = styled.View<ContainerProps>`
  background-color: ${({ theme }) => theme.color.white};
  border-radius: 12px;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  flex: ${({ flex }) => (flex ? 1 : 'none')};
  overflow: auto;
`;

interface InnerContainerProps {
  hasTitle: boolean;
}

const InnerContainer = styled.View<InnerContainerProps>`
  padding: ${({ hasTitle }) => (hasTitle ? '16px 32px 32px 32px' : '32px')};
`;

const TitleContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  padding: 16px 0;
  margin: 0 32px;
  border-bottom-width: 1px;
  border-bottom-color: ${({ theme }) => theme.color.lightPrimary};
`;

const Title = styled(OEText).attrs(({ theme }) => ({
  fontFamily: secondaryFontFamily,
  color: theme.color.dark3,
}))`
  text-transform: uppercase;
  letter-spacing: 1px;
`;
